import { createFileRoute } from '@tanstack/react-router';
import { ExecutiveDashboard } from '@/features/dashboard/ExecutiveDashboard';

export const Route = createFileRoute('/_authed/')({
  component: ExecutiveDashboard,
});
